/* eslint-disable no-useless-computed-key */
import React from 'react';
import {
  Card,
  Typography,
  Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    maxWidth: '970px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    ['@media (max-width: 922px)']: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: '568px'
    }
  },
  image: {
    maxWidth: '380px',
    width: '100%',
    objectFit: 'contain',
    maxHeight: '447px',
  },
  descriptionContainer: {
    width: '60%',
    margin: '0 0 0 auto',
    paddingLeft: '40px',
    ['@media (max-width: 922px)']: {
      maxWidth: '380px',
      width: '100%',
      margin: '0 auto',
      padding: '20px'
    }
  },
  mainHeading: {
    margin: '30px 0',
    fontWeight: '500',
    fontSize: '28px',
    color: '#000000',
    textTransform: 'uppercase',
    lineHeight: '1.2',
  },
  secondaryHeading: {
    margin: '30px 0',
    fontWeight: '400',
    fontSize: '24px',
    color: '#000000',
    textTransform: 'uppercase',
    lineHeight: '1.5',
  },
  description: {
    paddingBottom: '35px',
    fontWeight: '400',
    fontSize: '14px',
    color: '#000000',
    lineHeight: '1.5',
  },
  button: {
    width: '100%',
    maxWidth: '200px',
    marginBottom: '28px',
    borderRadius: '0',
    textTransform: 'uppercase',
    backgroundColor: '#3f4542',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#3f4542',
      color: '#fff'
    }
  }
}));

const RewardBlock = ({
  isBlockEnabled,
  contentValue,
  imageSrc
}) => {
  const classes = useStyles();

  return (
    <Card className="mt-5 p-8">
      <Typography variant="h4" className="mb-5">Preview</Typography>
      {isBlockEnabled == 1 ?
        <div className={classes.container}>
          <img
            src={imageSrc}
            alt="Reward Block Image"
            className={classes.image}
          />
          <div className={classes.descriptionContainer}>
            <div className={classes.mainHeading}>
              Rewards Program
            </div>
            <div className={classes.secondaryHeading}>
              Earn Rewards Every Time You Shop Online
            </div>
            <div
              className={classes.description}
              dangerouslySetInnerHTML={{__html: contentValue}}
            />
            <Button
              variant="contained"
              className={classes.button}
              disableRipple
            >
              Learn More
            </Button>
          </div>
        </div>
        :
        <Typography variant="body1" className="text-muted w-full text-center my-10">
          Reward Block is disabled.
        </Typography>
      }
    </Card>
  );
};

export default RewardBlock;
